module.exports = __webpack_public_path__ + "img/PEARLSAsset 213.2041b86.svg";